import React from "react"
import { ApolloClient } from "apollo-boost"
import { Router as RouterProps, withRouter } from "next/router"
import initApollo from "./initApollo"

interface Props {
    apolloState: any
    router: RouterProps
}

interface State {
    apolloClient: ApolloClient<any>
}

const withInitApolloClient = (App) => {
    class Apollo extends React.Component<Props, State> {
        state = {
            loading: true,
            apolloClient: null,
        }

        static displayName = "withApollo(App)"
        static getInitialProps

        constructor(props) {
            super(props)

            initApollo(this.props.router, this.props.apolloState).then((apolloClient) => {
                this.setState({ apolloClient: apolloClient })
            })
        }

        render() {
            return <App {...this.props} apolloClient={this.state.apolloClient} />
        }
    }

    if (App.getInitialProps) {
        Apollo.getInitialProps = App.getInitialProps
    }

    return withRouter(Apollo)
}

export default withInitApolloClient
